// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1YrVK","actions":"GroupTable_actions__1JCmz","deleteModalFooter":"GroupTable_deleteModalFooter__39F39"};